import React, { useEffect, useState } from "react";
import Label from "../Label/Label";
import HintLabel from "../HintLabel/HintLabel";
import ErrorLabelWithValue from "../ErrorLabelWithValue/ErrorLabelWithValue";
import InfoIcon from "../InfoIcon/InfoIcon";
import InputDescription from "../InputDescription/InputDescription";
import PendingFieldConfirmButton from "../PendingFieldConfirmButton/PendingFieldConfirmButton";
import "./file-field.scss";

const FileField = (props) => {
    const {
        id,
        className = "",
        type,
        label,
        placeholder,
        hintText,
        accept,
        value,
        previousValue,
        disabled,
        description,
        pending,
        error,
        isRequired,
        validations,
        width,
        onBlur,
        onChange,
        onUpload,
        onRemove,
    } = props;

    const [show, setShow] = useState(false);
    const [status, setStatus] = useState("");
    const handleToggle = () => setShow(!show);
    useEffect(() => {
        if (value !== previousValue && props.files && !error) {
            setStatus("inprogress");
            onUpload(props.files, props)
                .then((response) => {
                    if (
                        response &&
                        response.data &&
                        response.data.count &&
                        response.data.size
                    ) {
                        setStatus("complete");
                    } else {
                        setStatus("error");
                    }
                })
                .catch((response) => {
                    setStatus("error");
                });
        }
        if (value && error) {
            console.log("error.........", error);
            setStatus("error");
        }
        if (value && !props.files) {
            setStatus("complete");
        }
    }, [value, error]);

    const handleFileClick = () => {

        if (value && isUrl()) {
            var fileType = getFileType("Status", props.files).toLowerCase();
            var imageFileExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (imageFileExtensions.test(fileType)) {
                window.open(value, "_blank", `width=800, height=600`, `style="max - width: 100 %; max - height: 100 %;`); // Open image in a new popup window
            }
            else {                
                downloadUrlFiles(value, getFileTitle())
            }
            
        }
        else {
            openOrDownloadFile(readBase64DataString(3), readBase64DataString(1) + '.' + readBase64DataString(2));
        }
    };

    // this function is used to download files using url
    const downloadUrlFiles = async (url, filename) => {
        const data = await fetch(url)
        const blob = await data.blob()
        const objectUrl = URL.createObjectURL(blob)

        const link = document.createElement('a')

        link.setAttribute('href', objectUrl)
        link.setAttribute('download', filename)
        link.style.display = 'none'

        document.body.appendChild(link)

        link.click()

        document.body.removeChild(link)
    }
    const openOrDownloadFile=(base64String, outputFileName,fileURI='')=> {
        // Remove the data URI prefix if present
        const base64Data = base64String.replace(/^data:[^;]+;base64,/, '');
        // Convert the Base64 data to a Uint8Array
        const uint8Array = new Uint8Array(atob(base64Data).split('').map(char => char.charCodeAt(0)));

        // Create a Blob from the Uint8Array
        const blob = new Blob([uint8Array], { type: 'application/octet-stream' });
        var imageFileExtensions = /(\.jpg|\.jpeg|\.png)$/i;

        // If it's an image, open a new window to display it
        if (imageFileExtensions.test(outputFileName)) {
            
            const imageWindow = window.open('', '_blank', `width=800, height=600`);
            const imageUrl = window.URL.createObjectURL(blob);
            imageWindow.document.write(`<img src="${imageUrl}" alt="${outputFileName || 'Image'}"style="max-width: 100%; max-height: 100%;">`);
        } else {
            // If it's not an image, trigger a download
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = outputFileName || 'downloaded_file';
            link.click();
        }
    }

    const handleRemoveFile = () => {
        if (status !== "error") {
            onRemove(props.files || [{ name: getFileTitle() }], props);
        }
        setStatus("");
    };

    const formatBytes = (bytes) => {
        var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
        if (bytes!==0) {
            
            if (bytes == 0) return "0 Byte";
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
        } else
        {
            // Decode the base64 string to binary
            const binaryData = atob(readBase64DataString(3));

            // Get the length of the binary data (which represents the original file size)
            const fileSizeBytes = binaryData.length;

            var i = parseInt(Math.floor(Math.log(fileSizeBytes) / Math.log(1024)));
            return Math.round(fileSizeBytes / Math.pow(1024, i), 2) + " " + sizes[i];
        }
        
    };

    const getFileType = (status, files = [{ name: "" }]) => {
        if (files[0].name !== '') {
            if (status === "error") return "!";
            return (
                "." +
                ((value && value.split(".").pop().toUpperCase()) ||
                    (files &&
                        files[0] &&
                        files[0].name &&
                        files[0].name.split(".").pop().toUpperCase()))
            );
        } else{
            return '.' + readBase64DataString(2).toUpperCase();

        }
    };

    const getFileTitle = () => {
        if (isUrl()) {
            return (
                (value && value.split("/").pop()) ||
                (props.files && props.files[0] && props.files[0].name)
            );
        }
        else if(!props.files){
            return readBase64DataString(1) + '.' + readBase64DataString(2);
        }

    };

    const readBase64DataString = (partNumber) => {
        // Split the input string based on ';'
        var parts = value.split(';');
        // Check if the partNumber is valid
        if (partNumber >= 1 && partNumber <= parts.length) {
            // Return the specified part
            var chk = parts[partNumber - 1].trim();
            return parts[partNumber - 1].trim();
        } else {
            // If partNumber is out of range, return null or handle it as needed
            return null;
        }
    };

    // this function check value of activity is url or base64DataString
    const isUrl = () => {
        var urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
        return urlRegex.test(value);
    };

    return (
        <div className="input-field">
            <Label className={pending ? "pending-label" : ""}>{label}</Label>
            {value && status === "complete" ? (
                <div className={`input-field__wrapper ${className}`} style={{ width }}>
                    <UploadedFile
                        status={status}
                        title={getFileTitle()}
                        description={formatBytes(props.files?.[0].size??0)}
                        type={getFileType(status, props.files)}
                        style={{ width }}
                        onClose={handleRemoveFile}
                        onFileClick={handleFileClick}
                    />
                    {pending && <PendingFieldConfirmButton onClick={() => onBlur(value)} />}
                </div>
            ) : (
                <div className={`input-field__wrapper ${className}`} style={{ width }}>
                    <div className="input-field__inner-wrapper">
                        <div className="input-field__file">
                            <label
                                className={`input-field__file input-field__btn ${error ? "file-error" : ""
                                    }`}
                            >
                                <input
                                    id={id}
                                    name={id}
                                    type={type}
                                    accept={accept}
                                    placeholder={placeholder}
                                    title={hintText}
                                    disabled={disabled}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                />
                                <label htmlFor={id}>SELECT FILE...</label>
                                <ErrorLabelWithValue
                                    isRequired={isRequired}
                                    error={error}
                                    validations={validations}
                                />
                            </label>
                        </div>
                        {description && <InfoIcon onClick={handleToggle} active={show} />}
                    </div>
                    {(status === "inprogress" || status === "error") && value && (
                        <UploadedFile
                            status={status}
                            title={getFileTitle()}
                            description={
                                props.files &&
                                props.files[0] &&
                                formatBytes(props.files[0].size)
                            }
                            type={getFileType(status, props.files)}
                            onClose={handleRemoveFile}
                        />
                    )}
                    {hintText && <HintLabel>{hintText}</HintLabel>}
                    {description && show && (
                        <InputDescription>{description}</InputDescription>
                    )}
                </div>
            )}
        </div>
    );
};

const UploadedFile = ({
    title,
    description,
    type,
    status,
    className,
    style,
    onClose,
    onFileClick,
}) => {
    return (
        <div className={`uploaded-file ${status} ${className}`} style={style}>
            <div className="icon">{type}</div>
            <div className="file-info">
                <span className="file-name" onClick={onFileClick} >{title}</span>
                <span className="file-size">{description}</span>
            </div>
            <div className="progress-bar"></div>
            <span className="close" onClick={onClose} />
        </div>
    );
};

export default FileField;
